export default {
  raffles: [],
  pagination: {},
  raffle: {}
}
